import TriggerHandlerBase from '../trigger-handler-base';
import store from './store';
import { isMatchingUrls } from '../../../../utils';

// Updating History API methods to trigger events
const listenMethods = ['pushState', 'replaceState'];

listenMethods.forEach((methodName) => {
  const method = window.history[methodName];
  const eventName = methodName.toLowerCase();
  const onEventName = `on${eventName}`;

  window.history[methodName] = (...args) => {
    const [state, , url] = args;
    const eventData = { state, url };

    if (typeof window.history[onEventName] === 'function') {
      window.history[onEventName](eventData);
    }

    const event = new CustomEvent(eventName, { detail: eventData });
    window.dispatchEvent(event);

    return method.apply(window.history, args);
  };
});

export default class PageLoadTriggerHandler extends TriggerHandlerBase {
  constructor(ctx, nodeService) {
    super(ctx, nodeService, 'onPageLoad');
    this.store.registerModule('pageLoadTriggerStore', store);
    this.#setupRouteListeners();
  }

  initiate() {
    this.store.watch(
      (localstate) => localstate.pageLoadTriggerStore.route,
      (newValue) => {
        const trigger = this.getTriggers()?.find((tgr) => {
          try {
            return isMatchingUrls(newValue, tgr);
          } catch (error) {
            return false;
          }
        });

        if (trigger) {
          this.startConversation(trigger);
        }
      },
      { immediate: true }
    );

    this.isInitiated = true;
  }

  getTriggers() {
    return this.store.getters['chatbotStore/getTriggers']?.filter((trigger) => trigger.onPageLoad) ?? [];
  }

  #setupRouteListeners() {
    window.addEventListener('pushstate', this.#routeListener.bind(this));
    window.addEventListener('popstate', this.#routeListener.bind(this));
  }

  #routeListener(event) {
    const url = event.detail?.url || window.location.href;

    this.store.dispatch('pageLoadTriggerStore/setRoute', url);
  }
}
